function dateToText(d) {
  var h = d.getHours(),
      m = d.getMinutes(),
      s = d.getSeconds();
  if (m < 10) m = '0' + m;
  if (h < 10) h = '0' + h;
  if (s < 10) s = '0' + s;
  return h + ':' + m + ':' + s;
}

function updateClocks() {
  for (var i = 0; i < window.arrClocks.length; i++) {
    var c = window.arrClocks[i],
        o = window.arrOffsets[i];
    c.textContent = dateToText(new Date(new Date().getTime() + o));
  }
}

function startClocks() {
  var c = document.querySelector('.clock-time'),
      t = parseInt(c.getAttribute('timezone'), 10);
  window.arrClocks = [];
  window.arrOffsets = [];
  if (!isNaN(t)) {
    var T = t * 60 + new Date().getTimezoneOffset(),
        o = T * 60 * 1000;
    window.arrClocks.push(c);
    window.arrOffsets.push(o);
  }
  updateClocks();
  var clockID = setInterval(updateClocks, 1000);
}

setTimeout(startClocks, 100);
